'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.UserManagement.Common'];
module.exports = angular.module('AVRO.UserManagement.UserProfile', dependencies).directive('rmUserProfile', require('./directives/UserProfileDirective')).constant('UserManagementConstants', require('../constants/UserManagementConstants')).controller('UserProfileController', require('./controllers/UserProfileController'));